BatchGeoStore.addReducer("HeaderSort", function (state, action) {
  // state:
  // 0 = ascending
  // 1 = descending
  // index: column to sort on, -1 is default which is essentially by id
  state = state || {
    state: 0,
    index: -1,
    order: {},
  };

  switch (action.type) {
    case "HEADER_SORT_SET":
      return Object.assign({}, state, {
        state: action.state,
        index: action.index,
      });
    case "HEADER_SORT_SET_ORDER":
      return Object.assign({}, state, {
        order: action.order,
      });
    case "HEADER_SORT_DEFAULT":
      return Object.assign({}, state, {
        state: 0,
        index: -1,
        order: {},
      });
    default:
      return state;
  }
});
